import axios from "axios";

const filesService = {
  downloadTechDocs: () => {
    return axios.get('files/tech-docs/download', {
      responseType: 'blob',
    });
  }
};

export default filesService;